"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Surface3Wrapper = void 0;
const react_1 = __importStar(require("react"));
const lbp2_surface3_1 = require("@jeffreycwitt/lbp2.surface3");
const prop_types_1 = __importDefault(require("prop-types"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const FormControl_1 = __importDefault(require("react-bootstrap/FormControl"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const axios_1 = __importDefault(require("axios"));
const fa_1 = require("react-icons/fa");
require("./surface3wrapper.scss");
// import {runQuery} from './utils'
// import {basicInfoQuery} from './Queries'
//TODO: surface 3 needs to run in a wrapper which allows the user to choose between manifestations.
//TODO: rdf dbase needs to include first line numbers for paragraphs that start in the middle of al line.
const runQuery = (query) => {
    const sparqlEndpoint = "https://sparql.scta.info/ds/query";
    const queryPromise = axios_1.default.get(sparqlEndpoint, { params: { "query": query, "output": "json" } });
    return queryPromise;
};
const basicInfoQuery = (itemExpressionUri) => {
    // query info block, division, or item (possible also collection)
    const query = [
        "SELECT DISTINCT ?title ?structureType ?cmanifestation ?cmanifestationTitle ?manifestation ?manifestationTitle ?ctranscription ?manifestationCTranscription ?cdoc ?cxml ?expressionShortId ?longTitle ?topLevelExpression ?next ?previous ?inbox ?author ?authorTitle ?parent ",
        "WHERE { ",
        "<" + itemExpressionUri + "> <http://purl.org/dc/elements/1.1/title> ?title .",
        "<" + itemExpressionUri + "> <http://scta.info/property/structureType> ?structureType .",
        "<" + itemExpressionUri + "> <http://scta.info/property/hasCanonicalManifestation> ?cmanifestation .",
        "?cmanifestation <http://purl.org/dc/elements/1.1/title> ?cmanifestationTitle .",
        "<" + itemExpressionUri + "> <http://scta.info/property/hasManifestation> ?manifestation .",
        "?manifestation <http://purl.org/dc/elements/1.1/title> ?manifestationTitle .",
        // NOTE: the line below restricts the query result from including an option for manifestations that either don't manifest in a material item, and therefore do not have an image
        "?manifestation <http://scta.info/property/isOnZone> ?isOnZone .",
        "OPTIONAL {",
        "?manifestation <http://scta.info/property/hasCanonicalTranscription> ?manifestationCTranscription .",
        "?cmanifestation <http://scta.info/property/hasCanonicalTranscription> ?ctranscription .",
        "?ctranscription <http://scta.info/property/hasDocument> ?cdoc . ",
        "?ctranscription <http://scta.info/property/hasXML> ?cxml . ",
        "}",
        "<" + itemExpressionUri + "> <http://scta.info/property/shortId> ?expressionShortId .",
        "{",
        "<" + itemExpressionUri + "> <http://scta.info/property/isPartOfTopLevelExpression> ?topLevelExpression .",
        "}",
        "UNION",
        "{",
        "<" + itemExpressionUri + "> <http://scta.info/property/level> '1' .",
        "BIND(<" + itemExpressionUri + "> AS ?topLevelExpression) .",
        "}",
        "OPTIONAL {",
        "<" + itemExpressionUri + "> <http://scta.info/property/longTitle> ?longTitle .",
        "}",
        "OPTIONAL {",
        "?topLevelExpression <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
        "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .",
        "}",
        "OPTIONAL {",
        "<" + itemExpressionUri + "> <http://scta.info/property/next> ?next .",
        "}",
        "OPTIONAL {",
        "<" + itemExpressionUri + "> <http://scta.info/property/previous> ?previous .",
        "}",
        "OPTIONAL {",
        "<" + itemExpressionUri + "> <http://purl.org/dc/terms/isPartOf> ?parent .",
        "}",
        "<" + itemExpressionUri + "> <http://www.w3.org/ns/ldp#inbox> ?inbox . ",
        "}",
        "ORDER BY ?title"
    ].join('');
    return query;
};
const Surface3Wrapper = (props) => {
    const [manifestations, setManifestations] = (0, react_1.useState)([]);
    const [focusedManifestation, setFocusedManifestation] = (0, react_1.useState)(props.focusedManifestation);
    const [annotationsDisplay, setAnnotationsDisplay] = (0, react_1.useState)(props.annotationsDisplay);
    const [userAddedExpressionId, setUserAddedExpressionId] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        if (props.expressionid) {
            console.log("firing eid");
            getManifestations(props.expressionid);
        }
        else if (props.manifestations) {
            console.log("firing man");
            setManifestations(props.manifestations);
            props.focusedManifestation ? setFocusedManifestation(props.focusedManifestation) : setFocusedManifestation(props.manifestations[0].manifestation);
        }
    }, [props.expressionid, props.manifestations]);
    (0, react_1.useEffect)(() => {
        setAnnotationsDisplay(props.annotationsDisplay);
    }, [props.annotationsDisplay]);
    (0, react_1.useEffect)(() => {
        // this condition here; because if no focusedManifestation is set, the initial load will choose manifestations[0] as default
        // the conditional here prevents overriding this selection when no default focusedManifestation prop is set
        if (props.focusedManifestation) {
            setFocusedManifestation(props.focusedManifestation);
        }
    }, [props.focusedManifestation]);
    const getManifestations = () => {
        const results = runQuery(basicInfoQuery(props.expressionid));
        results.then((d) => {
            const manifestations = d.data.results.bindings.map((b) => {
                return {
                    manifestation: b.manifestation.value,
                    manifestationTitle: b.manifestationTitle.value,
                    transcription: b.manifestationCTranscription ? b.manifestationCTranscription.value : ""
                };
            });
            setManifestations(manifestations);
            if (props.focusedManifestation && manifestations.find((m) => m.manifestation === props.focusedManifestation)) {
                setFocusedManifestation(props.focusedManifestation);
            }
            else {
                setFocusedManifestation(manifestations[0].manifestation);
            }
        });
    };
    const displayManifestationsList = () => {
        const list = manifestations.map((m) => {
            return react_1.default.createElement("option", { key: "title-" + m.manifestation, value: m.manifestation }, m.manifestationTitle);
        });
        return list;
    };
    const displayManifestation = () => {
        const manifestation = manifestations.map((m) => {
            if (m.manifestation === focusedManifestation) {
                return react_1.default.createElement(lbp2_surface3_1.Surface3, { key: "surface-" + m.manifestation, manifestationid: m.manifestation, annotationsDisplay: annotationsDisplay, width: props.width, lineFocusId: props.lineFocusId, startWord: props.startWord, endWord: props.endWord });
            }
            else {
                return null;
            }
        });
        return manifestation;
    };
    const handleSetFocusedManifestation = (e) => {
        if (props.handleChangeManifestation) {
            props.handleChangeManifestation(e.target.value);
        }
        else {
            setFocusedManifestation(e.target.value);
        }
    };
    const handleSetAnnotationsDisplay = (viewType) => {
        if (props.handleToggleTextLinesView) {
            props.handleToggleTextLinesView(viewType);
        }
        else {
            setAnnotationsDisplay(viewType);
        }
    };
    return (react_1.default.createElement("div", { className: props.hidden ? "hidden" : "showing" },
        !props.hideSelectionList &&
            react_1.default.createElement("div", { className: "manifestationsList" },
                react_1.default.createElement(Form_1.default.Control, { size: "sm", as: "select", onChange: handleSetFocusedManifestation, value: focusedManifestation }, displayManifestationsList())),
        react_1.default.createElement("div", { className: "surfaceWrapper" },
            !props.hideDisplayChoice && focusedManifestation &&
                react_1.default.createElement("div", { className: "image-display-choice" },
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("span", { title: "Text Line View", onClick: () => { handleSetAnnotationsDisplay("lines"); } },
                            react_1.default.createElement(fa_1.FaList, null))),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("span", { title: "Paragraph View", onClick: () => { handleSetAnnotationsDisplay("paragraph"); } },
                            react_1.default.createElement(fa_1.FaParagraph, null))),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("span", { title: "Full Surface View", onClick: () => { handleSetAnnotationsDisplay("surface"); } },
                            react_1.default.createElement(fa_1.FaFile, null)))),
            react_1.default.createElement("div", { className: "imagesDisplay" }, displayManifestation())),
        userAddedExpressionId &&
            react_1.default.createElement(Surface3Wrapper, { expressionid: userAddedExpressionId, annotationsDisplay: annotationsDisplay, width: props.width, hidden: false, isDependentSurface3: true }),
        (!props.isDependentSurface3 && !props.hideCustomImageForm) &&
            react_1.default.createElement("div", { style: { "borderBottom": "1px solid rgba(0, 0, 0, 0.1)", "borderTop": "1px solid rgba(0, 0, 0, 0.1)", marginTop: "5px", padding: "5px" } },
                react_1.default.createElement("p", { style: { fontSize: "12px" } }, "Create custom user compare"),
                react_1.default.createElement(Form_1.default, { onSubmit: (() => setUserAddedExpressionId(value)), inline: "true" },
                    react_1.default.createElement(FormControl_1.default, { inline: "true", size: "sm", id: "text", type: "text", value: userAddedExpressionId, placeholder: "expression id", className: "mr-sm-2", onChange: (e) => { handleSetCustomExpressionId(e.target.value); } }),
                    react_1.default.createElement(Button_1.default, { inline: "true", size: "sm", type: "submit", style: { margin: "2px" } }, "Submit")))));
};
exports.Surface3Wrapper = Surface3Wrapper;
Surface3Wrapper.defaultProps = {
    expressionid: "",
    manifestations: [],
    hidden: false,
    focusedManifestation: "",
    annotationsDisplay: "paragraph",
    width: 500,
    isDependentSurface3: false,
    hideCustomImageForm: false
};
Surface3Wrapper.propTypes = {
    /**
    * @description expressionid
    */
    expressionid: prop_types_1.default.string,
    /**
    * @description this can used INSTEAD of supplying an expressionid; manifestation info can be manually supplied
    * if already known by containing component; using this will avoid an extra query call; to use, expressionid prop must be empty/undefined; if expressionid is supplied, manual supply of manifestations will be ignored
    * @deprecated while supplying the manifestations manually save a query call, it adds complexity that is better from the component to handle internally; thus this prop is depreciated and not highly recommended
    */
    manifestations: prop_types_1.default.array,
    /**
    * boolean indicating whether or not compoment should be mounted by still hidden
    */
    hidden: prop_types_1.default.bool,
    /**
    * indicates on which manifestation component to default focus.
    * manifestation value MUST be included in manifestations array
    * if not supplied, first manifestation in array will be supplied
    */
    focusedManifestation: prop_types_1.default.string,
    /**
    * indicates what kind of display is desired, "lines, paragraph, surface/null"
    */
    annotationsDisplay: prop_types_1.default.string,
    /**
    * @description desired image width
    */
    width: prop_types_1.default.number,
    /**
     * @description true or false value to hide (true) or show (false) the drop down selection list.
     * this is useful if only one manifestation is being shown. For a single manifestation, it might be better to use the Surface3 component
     * but if you also want the view toggle buttons that come with the Surface3Wrapper the hideSelectionList=true can reduce the unnecessary list and save some space
     */
    hideSelectionList: prop_types_1.default.bool,
    /**
     * @description true or false value to hide (true) or show (false) the custom image addition form
     */
    hideCustomImageForm: prop_types_1.default.bool,
    /**
     * @description: a true value value to indicate whether surface3 component is a custom user added component and therefore a child of a previous Surface3Wrapper component
     * default is value; if true, this will prevent the option to create another custom user added component
     */
    isDependentSurface3: prop_types_1.default.bool,
    /**
    * optional prop to allow parent container to reset default view prop
    */
    handleToggleTextLinesView: prop_types_1.default.func,
    /**
    * optional prop to allow parent container to reset default manifestation view
    */
    handleChangeManifestation: prop_types_1.default.func,
    /**
    * @descriptions props.startWord is the word token position that the desired passage begins on
    */
    startWord: prop_types_1.default.number,
    /**
    * @descriptions props.endWord is the word token position that the desired passage begins on
    */
    endWord: prop_types_1.default.number
};
//# sourceMappingURL=surface3wrapper.js.map